
import { Action } from "../actions/flyersFiltersActions";
import { ActionType } from "../actionTypes";
import {OptionTypeBase} from "react-select/src/types";

export interface FlyersFiltersDto {
    viewFilter: OptionTypeBase;
    classFilter: OptionTypeBase;
}

export class EditorFlyersActionsForPopupsInitialState implements FlyersFiltersDto {
    viewFilter = {
        value: "All",
        label: "All"
    };
    classFilter = {
        value: "All",
        label: "All"
    };
}

const initialState = new EditorFlyersActionsForPopupsInitialState();

const reducer = (state: FlyersFiltersDto = initialState, action: Action): FlyersFiltersDto => {
    switch (action.type) {
        case ActionType.CHANGE_FLYERS_VIEW_FILTER:
            return { ...state, viewFilter: action.payload };
        case ActionType.CHANGE_FLYERS_CLASSES_FILTER:
            return { ...state, classFilter: action.payload };
        default:
            return state;
    }
};

export default reducer;
